import classNames from 'classnames';
import { type ReactNode } from 'react';

import styles from './CardPayment.module.css';

type CardPaymentProps = {
  primarySlot: ReactNode;
  secondarySlot: ReactNode;
  tertiarySlot: ReactNode;
  /**
   * Handler that is called when the CardPayment is clicked
   */
  onClick: () => void;
  /**
   * className for the element
   */
  className?: string;
};

/**
 * Responsive component to display payment information.
 * Layout will change if inline-size goes below 320px
 */
export const CardPayment = ({
  onClick,
  primarySlot,
  secondarySlot,
  tertiarySlot,
  className,
}: CardPaymentProps) => {
  return (
    <div className={styles.container}>
      <button
        onClick={onClick}
        type="button"
        className={classNames(styles.cardPayment, className)}
      >
        <div className={styles.primarySlot}>{primarySlot}</div>
        <div aria-hidden="true" className={styles.secondarySlot}>
          {secondarySlot}
        </div>
        <div aria-hidden="true" className={styles.tertiarySlot}>
          {tertiarySlot}
        </div>
      </button>
    </div>
  );
};
